import { AiClient } from "@me8eon/aiclient";
import { ErrorsOr, mapErrorsOr } from "@me8eon/errors";
import { dereference, dollarsBracesVarDefn } from "@me8eon/template";

export const defaultPrompt = "You are a translator. The next message is the text you are to translate. If it's empty return the empty string. " +
    "" +
    "Don't return anything other than the translation. Especially don't return extra conversational words, as your output is directly used as the translated output" +
    "" +
    "Translate to ${targetLanguage}: ${query}. If it is already in ${targetLanguage}, just return the text." +
    "" +
    " Don't return any text other than the translation";

export type TranslateQueryConfig = {
    targetLanguage?: string //defaults to English
    query: string
    prompt?: string

}

export type TranslateQuery = (aiClient: AiClient, config: TranslateQueryConfig) => Promise<ErrorsOr<string>>;
export const translateQuery: TranslateQuery = async (aiClient: AiClient, { targetLanguage, query, prompt }: TranslateQueryConfig): Promise<ErrorsOr<string>> => {
    if (!targetLanguage) targetLanguage = "English";
    try {
        const content = dereference("prompt for translate", { query, targetLanguage }, prompt || defaultPrompt, { variableDefn: dollarsBracesVarDefn });
        const response = await aiClient([
            { role: "system", content },
            { role: "user", content: query }]);
        const firstResponse = response;
        return mapErrorsOr(firstResponse, value => value.message.content);
    } catch (e: any) {
        return { errors: [`Error translating query: ${query} to ${targetLanguage}: ${e.message}`], extras: e };
    }
};
